import React from 'react';
import { CimmplePayDocLayout } from './CimmplePayDocLayout';
import { authenticationMarkdown } from '../../../content/cimmplepay/authentication.md';

const Authentication: React.FC = () => {
  return (
    <CimmplePayDocLayout
      seoTitle="Authentication | CimmplePay Docs"
      seoDescription="CimmplePay API authentication: login, JWT bearer tokens, company switching, common auth endpoints, errors, and partner security guidance."
      markdown={authenticationMarkdown}
    />
  );
};

export default Authentication;
